export enum TransactionPaymentMethodEnum {
  CASH = 'cash',
  NON_CASH = 'non-cash',
  CREDIT = 'credit',
  AUTHORIZATION = 'authorization',
  DEBIT = 'debit'
}
